import * as React from 'react';
import {TransitionGroup} from 'react-transition-group';
import styled from '../../utils/styled';
import MessageFade from './private/MessageFade';
import Message from './private/Message';
import {MessagesProps} from './types';

const Root = styled('div')({
  boxSizing: 'border-box',
  position: 'fixed',
  zIndex: 1020,
  width: '100%',
  left: 0,
  top: 16,
  pointerEvents: 'none'
});

// TODO: add tests, intent icons
export default class Messages extends React.Component<MessagesProps, {}> {
  public render() {
    const {messages, onClose} = this.props;

    return (
      <Root>
        <TransitionGroup>
          {messages.map(messageProps => (
            <MessageFade key={messageProps.uid}>
              <Message onClose={onClose} {...messageProps} />
            </MessageFade>
          ))}
        </TransitionGroup>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Messages/Messages.tsx